import { render, staticRenderFns } from "./ClientContactDetails.vue?vue&type=template&id=0fe0e337&scoped=true&"
import script from "./ClientContactDetails.vue?vue&type=script&lang=js&"
export * from "./ClientContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClientContactDetails.vue?vue&type=style&index=0&id=0fe0e337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0e337",
  null
  
)

export default component.exports